// Bilingual translations
export const T = {
  brand: { en: "Rihai", hi: "रिहाई" },
  phone: { number: "+919140650818", display: "+91 91406 50818" },
  nav: {
    how: { en: "How it works", hi: "यह कैसे काम करता है" },
    cases: { en: "Case types", hi: "केस प्रकार" },
    stories: { en: "Stories", hi: "कहानियाँ" },
    fees: { en: "Fees", hi: "शुल्क" },
    faq: { en: "FAQ", hi: "प्रश्न" },
    blog: { en: "Blog", hi: "ब्लॉग" },
    cta: { en: "Find a Lawyer", hi: "वकील खोजें" },
  },
  hero: {
    overline: { en: "For families walking through the hardest days", hi: "उन परिवारों के लिए जो सबसे कठिन दिनों से गुज़र रहे हैं" },
    h1: {
      en: "Your loved one deserves a lawyer you can actually trust.",
      hi: "आपके अपनों के लिए एक ऐसा वकील, जिस पर आप सचमुच भरोसा कर सकें।",
    },
    sub: {
      en: "We help you understand the bail process, the timeline, and the real costs first — openly, in plain language. Then, only if you need one, we connect you to a verified lawyer. No munshis. No dallaals.",
      hi: "हम पहले आपको ज़मानत की प्रक्रिया, समय-रेखा और असली लागत — सरल भाषा में — साफ-साफ समझाते हैं। फिर, अगर आपको वकील की ज़रूरत हो, तभी सत्यापित वकील से जोड़ते हैं। कोई मुंशी नहीं। कोई दलाल नहीं।",
    },
    ctaPrimary: { en: "Talk to us about your case", hi: "अपने केस के बारे में बात करें" },
    ctaCall: { en: "Call now", hi: "अभी कॉल करें" },
    ctaSecondary: { en: "How Rihai works", hi: "यह कैसे काम करता है" },
    trust1: { en: "No munshis. No dallaals.", hi: "कोई मुंशी नहीं। कोई दलाल नहीं।" },
    trust2: { en: "Verified success rates.", hi: "सत्यापित सफलता दर।" },
    trust3: { en: "A human on the other side of every call.", hi: "हर कॉल पर एक इंसान, हमेशा।" },
  },
  problem: {
    overline: { en: "The truth nobody tells you", hi: "एक सच जो कोई नहीं बताता" },
    h2: {
      en: "The legal system feels like a bottomless pit. It isn't — you just haven't been shown the path.",
      hi: "कानूनी व्यवस्था एक अंतहीन खाई जैसी लगती है। लेकिन ऐसा नहीं है — बस अब तक किसी ने रास्ता नहीं दिखाया।",
    },
    body: {
      en: "You've been passed between strangers who promise everything and deliver nothing. The munshi outside the court, the ‘contact’ someone gave you, the lawyer who stopped picking up. Each one took a little more of your money — and a lot more of your peace.\n\nWe built Rihai because we've stood exactly where you're standing.",
      hi: "आप अजनबियों के बीच घूमते रहे हैं जो सब कुछ वादा करते हैं और कुछ नहीं देते। कोर्ट के बाहर का मुंशी, किसी का बताया गया 'कॉन्टैक्ट', वो वकील जिसने फोन उठाना बंद कर दिया। हर किसी ने आपके पैसे लिए — और उससे भी ज़्यादा, आपकी मानसिक शांति।\n\nहमने Rihai इसलिए बनाया क्योंकि हम भी वहीं खड़े थे, जहाँ आप आज हैं।",
    },
  },
  crisis: {
    overline: { en: "The scale of silence", hi: "एक चुप्पी का पैमाना" },
    h2: {
      en: "The process is punishment.",
      hi: "यही प्रक्रिया ही सज़ा बन जाती है।",
    },
    stat1: {
      num: "5,11,000+",
      label: {
        en: "People in Indian prisons today.",
        hi: "आज भारतीय जेलों में बंद लोग।",
      },
    },
    stat2: {
      num: "73%",
      label: {
        en: "Are undertrials. Not convicted. Not proven guilty. Just waiting.",
        hi: "विचाराधीन हैं। दोषी सिद्ध नहीं। कसूरवार साबित नहीं। बस इंतज़ार में।",
      },
    },
    stat3: {
      num: "3,71,000",
      label: {
        en: "Lives on pause. Trials that can take years to conclude.",
        hi: "ज़िंदगियाँ रुकी हुई हैं। मुक़दमे जो सालों तक चल सकते हैं।",
      },
    },
    over: {
      en: "Indian jails run at ~113% of sanctioned capacity — 4.5 lakh beds for 5.11 lakh people.",
      hi: "भारतीय जेलें अपनी क्षमता से ~113% पर चलती हैं — 4.5 लाख बिस्तर पर 5.11 लाख लोग।",
    },
    familyH: {
      en: "For every person inside, a family stands outside — serving the same sentence.",
      hi: "हर एक इंसान अंदर है, तो बाहर एक पूरा परिवार भी वही सज़ा भुगत रहा है।",
    },
    familyBody: {
      en: "Children grow up without a parent. Rent goes unpaid. Reputations rot in the neighbourhood. ‘Undertrial’ does not mean innocent-yet-imprisoned — it means an entire home is imprisoned along with them. This is not just their crisis. It is your family's crisis.",
      hi: "बच्चे माता-पिता के बिना बड़े होते हैं। किराया रुक जाता है। मोहल्ले में इज़्ज़त ख़त्म हो जाती है। 'विचाराधीन' का मतलब सिर्फ 'बेकसूर लेकिन बंद' नहीं — इसका मतलब है पूरा घर उनके साथ बंद है। यह सिर्फ उनका संकट नहीं। यह आपके पूरे परिवार का संकट है।",
    },
    ripple1: { en: "In custody", hi: "हिरासत में" },
    ripple2: { en: "Family outside — living the same sentence", hi: "बाहर परिवार — वही सज़ा भुगतता हुआ" },
    source: {
      en: "Source: National Crime Records Bureau (NCRB), Prison Statistics India.",
      hi: "स्रोत: राष्ट्रीय अपराध रिकॉर्ड ब्यूरो (NCRB), प्रिज़न स्टैटिस्टिक्स इंडिया।",
    },
    cta: {
      en: "Don't let the process keep punishing you.",
      hi: "इस प्रक्रिया को और सज़ा बनने मत दीजिए।",
    },
  },

  how: {
    overline: { en: "How Rihai works", hi: "Rihai कैसे काम करता है" },
    h2: { en: "Three quiet steps. No noise, no runaround.", hi: "तीन शांत कदम। न शोर, न भटकाव।" },
    s1: {
      title: { en: "Tell us what's happening", hi: "हमें बताइए क्या हो रहा है" },
      body: { en: "A short form — or a call with a human — to understand the case, the charges, and the urgency.", hi: "एक छोटा फॉर्म — या किसी इंसान से बातचीत — ताकि हम केस, आरोप और तात्कालिकता समझ सकें।" },
    },
    s2: {
      title: { en: "Meet a verified lawyer", hi: "एक सत्यापित वकील से मिलिए" },
      body: { en: "We match you with lawyers whose High Court win-rate we can actually show you — not just claim.", hi: "हम आपको ऐसे वकीलों से जोड़ते हैं जिनकी हाई कोर्ट में जीत की दर हम आपको दिखा सकते हैं — सिर्फ दावा नहीं करते।" },
    },
    s3: {
      title: { en: "Move forward, together", hi: "आगे बढ़िए, साथ" },
      body: { en: "Pay a transparent flat connection fee. Your lawyer takes it from there — and we stay on the line if you need us.", hi: "एक पारदर्शी फ्लैट फ़ीस दीजिए। वकील आगे का काम संभालेंगे — और अगर ज़रूरत हो, हम फोन पर मौजूद रहेंगे।" },
    },
  },
  cases: {
    overline: { en: "Where Rihai helps today", hi: "Rihai आज कहाँ मदद करता है" },
    h2: { en: "Built for the moment that hurts most: the arrest.", hi: "जब सबसे ज़्यादा तकलीफ़ होती है, उसी पल के लिए बना है: गिरफ़्तारी।" },
    items: {
      bail: {
        en: "Bail",
        hi: "ज़मानत",
        tag: { en: "Our focus", hi: "हमारा फ़ोकस" },
        desc: {
          en: "Regular, anticipatory, and interim bail — matched with lawyers whose High Court bail win-rates we can actually show you.",
          hi: "साधारण, अग्रिम और अंतरिम ज़मानत — ऐसे वकीलों के साथ जिनकी हाई कोर्ट में ज़मानत दिलाने की सफलता दर हम आपको दिखा सकते हैं।",
        },
        points: {
          regular: {
            en: "Regular bail — post-arrest, moved quickly.",
            hi: "साधारण ज़मानत — गिरफ़्तारी के बाद, तेज़ी से।",
          },
          anticipatory: {
            en: "Anticipatory bail — before arrest, filed with care.",
            hi: "अग्रिम ज़मानत — गिरफ़्तारी से पहले, ध्यान से।",
          },
          interim: {
            en: "Interim relief — the first calm hours matter most.",
            hi: "अंतरिम राहत — पहले कुछ घंटे सबसे अहम होते हैं।",
          },
        },
      },
    },
    more: {
      en: "More categories, coming soon.",
      hi: "अन्य श्रेणियाँ, जल्द ही।",
    },
  },
  social: {
    overline: { en: "Voices that trusted us", hi: "जिन्होंने हम पर भरोसा किया" },
    h2: { en: "Real relief, in their own words.", hi: "असली राहत, उनके अपने शब्दों में।" },
    t1: { quote: { en: "Rihai was a lifeline during the most difficult time of our life. Their transparency about lawyer success rates saved us from being exploited, and their patience made all the difference.", hi: "Rihai हमारी ज़िंदगी के सबसे कठिन समय में एक सहारा था। वकीलों की सच्ची जानकारी ने हमें ठगे जाने से बचाया।" }, name: "Meera S.", city: { en: "Lucknow", hi: "लखनऊ" } },
    t2: { quote: { en: "For the first time, someone spoke to me like a human being — not a case number. My brother got bail in nine days.", hi: "पहली बार किसी ने मुझसे इंसान की तरह बात की — केस नंबर की तरह नहीं। मेरे भाई को नौ दिन में ज़मानत मिल गई।" }, name: "Arif K.", city: { en: "Delhi", hi: "दिल्ली" } },
    t3: { quote: { en: "I had already lost ₹80,000 to a middleman. Rihai's lawyer took the case, refused any nonsense, and won.", hi: "मैं पहले ही ₹80,000 एक दलाल को दे चुका था। Rihai के वकील ने केस लिया, कोई बकवास नहीं की, और जीत गया।" }, name: "Sunil R.", city: { en: "Patna", hi: "पटना" } },
  },
  about: {
    overline: { en: "Why Rihai exists", hi: "Rihai क्यों बना" },
    h2: { en: "Because we lived it too.", hi: "क्योंकि हम भी यही जी चुके हैं।" },
    body: {
      en: "One phone call from a police station changed our family. What followed — the confusion, the strangers asking for money, the lawyers who vanished — is what most of India lives through in silence.\n\nRihai is the platform we wish we'd had. Nothing more, nothing less.",
      hi: "एक पुलिस स्टेशन से आए एक फोन ने हमारे परिवार को बदल दिया। उसके बाद जो हुआ — भ्रम, पैसे माँगते अजनबी, गायब होते वकील — भारत का बड़ा हिस्सा इसे चुपचाप झेलता है।\n\nRihai वही मंच है जो हमें उस समय चाहिए था। इससे कम नहीं, इससे ज़्यादा नहीं।",
    },
  },
  fees: {
    overline: { en: "Transparent fees", hi: "पारदर्शी शुल्क" },
    h2: { en: "One number. Said out loud.", hi: "एक संख्या। साफ-साफ कही गई।" },
    a: {
      title: { en: "Flat lawyer fee", hi: "फ्लैट वकील शुल्क" },
      body: {
        en: "A single, flat, fully-disclosed fee for your bail lawyer — quoted upfront, agreed in writing, and never negotiated at the courtroom door. No commissions, no surprises, no middlemen.",
        hi: "आपके ज़मानत वकील के लिए एक तय, पारदर्शी और लिखित शुल्क — कोर्ट के बाहर मोल-भाव नहीं, कोई कमीशन नहीं, कोई अचरज नहीं, कोई बिचौलिया नहीं।",
      },
      points: {
        one: { en: "Quoted upfront, before you commit.", hi: "प्रतिबद्धता से पहले ही तय।" },
        two: { en: "Same fee for you as for anyone else.", hi: "आपके लिए वही शुल्क, जो सबके लिए।" },
        three: { en: "Paid to the lawyer, not a middleman.", hi: "सीधे वकील को, बिचौलिए को नहीं।" },
      },
    },
  },
  faq: {
    overline: { en: "Questions on your mind", hi: "आपके मन के सवाल" },
    h2: { en: "You should ask everything. So we answered.", hi: "आपको सब पूछना चाहिए। इसलिए हमने जवाब दिए।" },
    items: [
      { q: { en: "How do you verify lawyers?", hi: "आप वकीलों को कैसे सत्यापित करते हैं?" }, a: { en: "We match bar registrations, cross-check High Court cause lists, and compute category-wise win rates from public judgment data. Only lawyers with verifiable outcomes appear on Rihai.", hi: "हम बार पंजीकरण मिलाते हैं, हाई कोर्ट रिकॉर्ड जाँचते हैं, और सार्वजनिक फैसलों से श्रेणी-वार सफलता दर निकालते हैं। केवल सत्यापित नतीजों वाले वकील ही Rihai पर आते हैं।" } },
      { q: { en: "What does it cost?", hi: "इसकी लागत क्या है?" }, a: { en: "A single, flat, fully-disclosed lawyer fee — quoted upfront and agreed in writing before you commit. No commissions, no hidden charges, no middleman payments.", hi: "एक तय, पारदर्शी और लिखित वकील शुल्क — प्रतिबद्धता से पहले ही बताया जाता है। कोई कमीशन नहीं, कोई छुपा भुगतान नहीं, कोई बिचौलिया नहीं।" } },
      { q: { en: "How fast can I talk to a lawyer?", hi: "मैं वकील से कितनी जल्दी बात कर सकता/सकती हूँ?" }, a: { en: "For urgent matters (like fresh arrests), we aim to connect you within a few hours. Otherwise, within 24 hours.", hi: "जल्दी वाले मामलों में हम कुछ घंटों में जोड़ने की कोशिश करते हैं। बाकी में 24 घंटे के अंदर।" } },
      { q: { en: "What kind of emotional support do you give?", hi: "आप किस प्रकार की भावनात्मक सहायता देते हैं?" }, a: { en: "A chatbot for immediate reassurance, and real humans on the phone who've lived through this. We aren't therapists — but we won't rush you either.", hi: "तुरंत सहारे के लिए एक चैटबॉट, और फोन पर असली इंसान — जिन्होंने यह सब झेला है। हम थेरेपिस्ट नहीं हैं — लेकिन आपको जल्दबाज़ी में नहीं डालेंगे।" } },
      { q: { en: "Is my information confidential?", hi: "क्या मेरी जानकारी गोपनीय है?" }, a: { en: "Yes. Your details are shared only with the specific lawyer you agree to. Nothing is sold. Nothing is public.", hi: "हाँ। आपकी जानकारी केवल उस वकील से साझा होगी जिसकी आप सहमति देंगे। कुछ भी बेचा नहीं जाता। कुछ भी सार्वजनिक नहीं।" } },
    ],
  },
  form: {
    overline: { en: "Start here", hi: "यहाँ से शुरू करें" },
    h2: { en: "Tell us what's happening. We'll take it from here.", hi: "बताइए क्या हो रहा है। आगे हम संभालेंगे।" },
    sub: { en: "Fill this once. A verified lawyer will call you back — no middleman in between.", hi: "एक बार भरिए। सत्यापित वकील आपको वापस कॉल करेगा — बीच में कोई दलाल नहीं।" },
    name: { en: "Your name", hi: "आपका नाम" },
    phone: { en: "Phone number", hi: "फ़ोन नंबर" },
    email: { en: "Email (optional)", hi: "ईमेल (वैकल्पिक)" },
    city: { en: "City", hi: "शहर" },
    caseType: { en: "Case type", hi: "केस का प्रकार" },
    situation: { en: "Briefly, what's happening?", hi: "संक्षेप में बताइए, क्या हो रहा है?" },
    urgency: { en: "How urgent is this?", hi: "यह कितना ज़रूरी है?" },
    urgencyOptions: {
      immediate: { en: "Immediate (arrest today/yesterday)", hi: "तुरंत (आज/कल गिरफ़्तारी)" },
      week: { en: "Within a week", hi: "एक सप्ताह के भीतर" },
      normal: { en: "Just exploring", hi: "फिलहाल जानकारी लेना" },
    },
    submit: { en: "Request a callback", hi: "कॉलबैक का अनुरोध करें" },
    success: { en: "We've got you. A Rihai counselor will call you shortly.", hi: "हम आपके साथ हैं। Rihai का सलाहकार जल्द ही कॉल करेगा।" },
    error: { en: "Something went wrong. Please try again or WhatsApp us.", hi: "कुछ गड़बड़ हो गई। कृपया पुनः प्रयास करें या WhatsApp पर संपर्क करें।" },
  },
  closing: {
    h2: { en: "You don't have to figure this out alone.", hi: "आपको यह अकेले नहीं झेलना है।" },
    body: { en: "One form. One honest lawyer. One less sleepless night.", hi: "एक फॉर्म। एक ईमानदार वकील। एक कम बेचैन रात।" },
  },
  footer: {
    tag: { en: "The end of legal loneliness.", hi: "कानूनी अकेलेपन का अंत।" },
    privacy: { en: "Privacy", hi: "गोपनीयता" },
    terms: { en: "Terms", hi: "शर्तें" },
    contact: { en: "Contact", hi: "संपर्क" },
    copy: { en: "© 2026 Rihai. Built with empathy in India.", hi: "© 2026 Rihai. भारत में सहानुभूति से बना।" },
  },
  chat: {
    title: { en: "Talk to Rihai", hi: "Rihai से बात करें" },
    subtitle: { en: "We answer with empathy — not scripts.", hi: "हम स्क्रिप्ट नहीं, दिल से जवाब देते हैं।" },
    placeholder: { en: "Type your worry here…", hi: "अपनी चिंता यहाँ लिखिए…" },
    welcome: {
      en: "Hello. Whatever you're going through — you did the right thing by reaching out. Tell me what's happening, and I'll walk with you.",
      hi: "नमस्ते। आप जो भी झेल रहे हैं — यहाँ आना सही कदम था। बताइए क्या हो रहा है, मैं आपके साथ हूँ।",
    },
    send: { en: "Send", hi: "भेजें" },
  },
  blog: {
    overline: { en: "The Rihai Journal", hi: "Rihai जर्नल" },
    h2: { en: "Plain-spoken guides for the legal storm.", hi: "कानूनी तूफ़ान के लिए साफ बात करती लिखाइयाँ।" },
    read: { en: "Read", hi: "पढ़ें" },
    back: { en: "Back to journal", hi: "जर्नल पर वापस" },
  },
  admin: {
    title: { en: "Rihai Admin", hi: "Rihai एडमिन" },
    login: { en: "Enter admin token", hi: "एडमिन टोकन डालें" },
    signin: { en: "Sign in", hi: "साइन इन" },
    leads: { en: "Leads", hi: "लीड्स" },
    total: { en: "Total leads", hi: "कुल लीड्स" },
    logout: { en: "Log out", hi: "बाहर निकलें" },
  },
};

export const pick = (obj, lang) => (obj && (obj[lang] ?? obj.en ?? "")) || "";
